import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useBankStore } from "../store";

export const deleteBank = ({ churchId, bankId }) => {
  return axios.delete(`/churches/${churchId}/banks/${bankId}`);
};

export const useDeleteBank = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeUpdateBankAccountModal =
    useBankStore.getState().closeUpdateBankAccountModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("banks");
      queryClient.invalidateQueries("banks-paginated");

      setNotification({
        type: "success",
        message: "Bank deleted successfully!"
      });

      closeUpdateBankAccountModal();
    },
    ...config,
    mutationFn: deleteBank
  });
};
